import React from 'react';
import { UserFetchJson } from '../../userFetch';
import LogsTable from './logsTable';
import { Log, LogResponse, LogsContext, LogsProvider } from './logsContext';
import { useContextSelector } from 'use-context-selector';

const LogsContent = function ({ isSuperAdmin }: { isSuperAdmin?: boolean }) {

  const dispatch = useContextSelector(LogsContext, (c) => c.dispatch);
  const reloadNeeded = useContextSelector(LogsContext, (c) => c.state.reloadNeeded);

  const fetchLogs = () => {
    if (!reloadNeeded) {
      return;
    }

    UserFetchJson('/api/logs?item_per_page=5000')
      .then((response: LogResponse) => {
        const pageIndexes = Array.from(Array(response.total_pages).keys()).slice(1).map(index => index + 1); // Skip the first page as it's already fetched
        return Promise.all([Promise.resolve(response), ...pageIndexes.map((pageIndex) => {
          return UserFetchJson(`/api/logs?item_per_page=5000&page=${pageIndex}`);
        })]);
      })
      .then((logsResponses: LogResponse[]) => {
        const allLogs = logsResponses.reduce((acc, response) => {
          return acc.concat(response.items);
        }, [] as Log[]);
        dispatch({
          type: 'SET_LOGS',
          payload: allLogs
        });
      });
  }

  React.useEffect(() => {
    fetchLogs();
  }, [reloadNeeded]);

  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.altKey && e.code === 'KeyR') {
        e.preventDefault();
        dispatch({
          type: 'RELOAD_LOGS'
        });
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <LogsTable isSuperAdmin={isSuperAdmin} />
  );
}

export default React.memo(LogsContent);